var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"row mb-0"},[_vm._l((_vm.fields),function(field){return [_c('dt',{key:((field.key) + "-label"),staticClass:"col-5"},[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('dd',{key:field.key,staticClass:"col-7"},[_vm._v(_vm._s(_vm.displayValue(field.key)))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669fff35","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Horses/HorseMergeProfile.vue
// module id = 1374
// module chunks = 13